import DocumentationElement from "../documentation/DocumentationElement"
import { useLocation, useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"
import Documentation from "../documentation/Documentation"

interface DocumentationComponentProps {
    children: string
    documentation: DocumentationElement
    location?: "top_left" | "top_right" | "bottom_left" | "bottom_right"
    disableLink?: boolean // NEU: Link deaktivieren (z.B. für Überschriften)
}

function DocumentationComponent(props: DocumentationComponentProps) {
    const navigate = useNavigate()
    const location = useLocation()

    if (props.disableLink) {
        // Kein Link, keine Unterringelung
        return <span>{props.children}</span>;
    }

    return (
        <>
            <span
                onClick={() =>
                    navigate(
                        NavigationPaths[
                            NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW_INDEX_AND_REDIRECT
                        ].pathBuilder([
                            String(Documentation.indexOf(props.documentation)),
                            String(location.pathname)
                        ])
                    )
                }
                className={
                    "decoration-dotted underline text-primary-600 cursor-pointer hover:text-primary-700 p-2 break-keep"
                }>
                {props.children}
            </span>
        </>
    )
}

export default DocumentationComponent
